/**
 * The information needed by the TierLock component. Can be implemented by other
 * component config or prop types that need to apply tiering
 */
export interface TieringConfig {
  featureName: TieringFeatures;
  showBadge: boolean;
  disabledBehavior: TieringBehaviors;
}

/**
 * Feature Codes as defined by Works Manager and the Subscription service
 * @see https://docs.google.com/spreadsheets/d/1Yjm6iXUuYgELZ98NDlkO3NSjf9ouUJtOeEJty3Id5aE/edit?gid=830948012#gid=830948012
 */
export enum TieringFeatures {
  WorksManager = 'FEA-WRKSMGR',
  SiteVis = 'FEA-SITEVIZEDIT',
  DataPrep = 'FEA-DATAEDIT',
  Measurements = 'FEA-MEASUREEDIT',
  MixedFleet = 'FEA-MIXFLEETEDIT',
}

/**
 * Defines the possible behaviors for a component if the user lacks the needed license to access it
 */
export enum TieringBehaviors {
  Unrestricted = 'unrestricted',
  Restricted = 'restricted',
  Hidden = 'hidden',
}
